<template>
    <div class="ibox-content">
        <div class="row">
            <div class="col-6">
                <div v-if="!contract.isDetailed">
                    {{ __('with_chosen') }}
                    <button :disabled="!isOpened || !isCheckedAny"
                            v-if="contract.type.in_droplist == 'invoice_pl' ?  getPermission('perm_route_records.contracts.edit-pl') : getPermission('perm_route_records.contracts.edit-adding')"
                            class="btn btn-primary btn-sm m-l"
                            type="button"
                            @click.prevent="detachDocuments"
                    >
                        {{ __('detach_document_from_contract') }}
                    </button>
                </div>
            </div>
            <div class="col-6 no-padding text-right">
                <button v-if="!contract.isDetailed && (contract.type.in_droplist == 'invoice_pl' ?  getPermission('perm_route_records.contracts.edit-pl') : getPermission('perm_route_records.contracts.edit-adding'))"
                        :disabled="!(isOpened && !neededCorrection)"
                        class="btn btn-primary btn-sm m-l"
                        type="button"
                        @click="openAttachDocumentModal"
                >
                    {{ __('attach_document_to_contract') }}
                </button>
                <button v-if="!['adding_sell', 'adding_buy'].includes(contract.type.type_name) && getPermission('perm_route_records.documents.create.for-contract')"
                    :disabled="!(isOpened && !neededCorrection) || !contract.canIssueDocument"
                        class="btn btn-primary btn-sm"
                        type="button"
                        @click="createInvoice">
                    {{ __('issue_an_invoice') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {DocumentService} from "../../../../modules/document/services/DocumentService";
import Events from "../../../../services/Events";
import hasPermissions from "../../../../mixins/hasPermissions";
import hasTooltips from "../../../../mixins/hasTooltips";
import inputEmit from "../../../../mixins/inputEmit";
import hasErrors from "../../../../mixins/hasErrors";
export default {
    name: "ContractDocumentButtons",
    props: {
        contract: {
            type: Object,
            required: true,
        },
        checkedDocuments: {
            type: Array,
            required: true,
        },
        isWholeView: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    mixins: [hasPermissions],
    data() {
        return {
            documentService: new DocumentService({}),
        };
    },
    methods: {
        createInvoice() {
            window.location.href = this.createInvoiceUrl;
        },
        openAttachDocumentModal() {
            Events.$emit('openConnectDocumentContract');
        },
        async detachDocuments() {
            toggleLoader();
            const documentIds = await this.documentService.getRelatedDocumentsIds(this.checkedDocuments);

            if (documentIds.length > 0) {
                try {
                    const {data} = await this.axios.post('/records/documents/detach-from-contract', {
                        documentIds: this.checkedDocuments,
                        contractID: this.contract.id,
                    });
                    toastr['success'](data).css('border', '0px');
                    location.reload();
                } catch (e) {
                    toggleLoader(false);
                    toastr['error'](e).css('border', '0px');
                }
            } else {
                toggleLoader(false);
            }
        },
    },
    computed: {
        createInvoiceUrl() {
            return `/records/documents/select-create-for-contract/${this.contract.id}`;
        },
        isOpened() {
            return this.contract.status === 'opened';
        },
        isCheckedAny() {
            return this.checkedDocuments.length > 0;
        },
        neededCorrection() {
            return this.contract.correctionNeeded;
        },
    },
};
</script>
